import PropTypes from 'prop-types';

import {OERenderMode} from '../../../../react-oe/oe-types';
import {OEObjectModelValueTypes, OEObjectModelValueEditTypes, OEObjectModelValueCellStyleOptions} from '../../../elements/object-model-value-edit/oe-object-model-value-edit-model';
import {OEMediaType} from '../../../../react-oe/oe-types';
import {OEMediaViewerContentType} from '../../../../lib/oe-types';
import OEIconCodes from '../../../../lib/oe-icon-codes';

export const OEFunctionFragmentType = {
    noOp:                           0,
    makeReachable:                  1,
    contextMenuSelect:              2,
    contextMenuFadeOther:           3,
    contextMenuHideOther:           4,
    selectionControllerSelect:      5,
    centerCamera:                   6,
    zoomOutCamera:                  7,
    setUIState:                     8,
    setMediaCenterItem:             9,
    showMedia:                      10,
    debugOutput:                    11,
    setNoteText:                    12,
    saveNote:                       13,
    changeSlideProps:               14,
    changeActiveSlide:              15,
    changeNoteProps:                16,
    changePresNoteProps:            17,
    applyNoteAddState:              18,
    applyPresNoteAddState:          19,
    triggerNoteAttrSignal:          20,
    userNotification:               21,
    triggerPresNoteAttrSignal:	    22,
    applyPreset:                    23,
    changeComponent:                24,

    stringTable: [
        'noOp', 'makeReachable', 'contextMenuSelect', 'contextMenuFadeOther', 'contextMenuHideOther', 'selectionControllerSelect', 'centerCamera',
        'zoomOutCamera', 'setUIState', 'setMediaCenterItem', 'showMedia', 'debugOutput', 'setNoteText', 'saveNote', 'changeSlideProps', 'changeActiveSlide',
        'changeNoteProps', 'changePresNoteProps', 'applyNoteAddState', 'applyPresNoteAddState', 'triggerNoteAttrSignal', 'userNotification', 'triggerPresNoteAttrSignal',
        'applyPreset', 'changeComponent'
    ],
    
    toString: function(type) {
        return typeof(type) !== 'number' || type < 0 || type >= this.stringTable.length ? undefined : this.stringTable[type];
    }
};

//
export const OEFunctionFragmentIcons = {
    noOp:                           '\u00FF',
    makeReachable:                  '\u00FF',
    contextMenuSelect:              '\u00FF',
    contextMenuFadeOther:           '\u00FF',
    contextMenuHideOther:           '\u00FF',
    selectionControllerSelect:      '\u00FF',
    centerCamera:                   '\u00FF',
    zoomOutCamera:                  '\u00FF',
    setUIState:                     '\u00FF',
    setMediaCenterItem:             OEIconCodes.mediaCenter,
    showMedia:                      '\u00C4',
    debugOutput:                    '\uF27B',
    setNoteText:                    {code: OEIconCodes.note, subCode: '\uF031'},
    changeNoteProps:                {code: OEIconCodes.note, subCode: '\uF0AD'},
    applyNoteAddState:              {code: OEIconCodes.note, subCode: OEIconCodes.noteAddState},
    saveNote:                       {code: OEIconCodes.note, subCode: '\uF0C7'},
    triggerNoteAttrSignal:          {code: OEIconCodes.note, subCode: OEIconCodes.noteAttribute},
    changePresNoteProps:            {code: OEIconCodes.note, subCode: '\uF0AD', subCode2: OEIconCodes.presentation},
    applyPresNoteAddState:          {code: OEIconCodes.note, subCode: OEIconCodes.noteAddState, subCode2: OEIconCodes.presentation},
    triggerPresNoteAttrSignal:      {code: OEIconCodes.note, subCode: OEIconCodes.noteAttribute, subCode2: OEIconCodes.presentation},
    changeSlideProps:               {code: OEIconCodes.presentation, subCode: '\uF0AD', className: 'slide'},
    changeActiveSlide:              {code: OEIconCodes.presentation, subCode: '\uF064', className: 'slide'},
    userNotification:               '\uF075',
    applyPreset:                    '\u2004',
    changeComponent:                OEIconCodes.tree,

    iconForType(type)   {
        let str = OEFunctionFragmentType.toString(type);
        return str && this[str] ? this[str] : '\u00FF';
    }
};

//
export const OEFunctionShowMediaFlags = {
    none:                           0,
    autoplay:                       1,
    autoclose:                      2,
    def:                            0
};

//
export const OEFunctionFragmentParameterModel = {

    setMediaCenterItem: {
        resourceID:                 {type: OEObjectModelValueTypes.string, allowUndefined: true},
        pos:                        {type: OEObjectModelValueTypes.integer}
    },

    showMedia: {
        mediaType: {
            type:                   OEObjectModelValueTypes.integer,
            editType:               OEObjectModelValueEditTypes.dropdown,
            entries: [
                {value: OEMediaType.image, label: OEMediaViewerContentType.image},
                {value: OEMediaType.video, label: OEMediaViewerContentType.video},
                {value: OEMediaType.web, label: OEMediaViewerContentType.web},
                {value: OEMediaType.pdf, label: OEMediaViewerContentType.pdf}
            ],
            defaultDropdownTitle:   OEMediaType.none
        },
        path:                       {type: OEObjectModelValueTypes.string, allowUndefined: true},
        pathId:                     {type: OEObjectModelValueTypes.string, allowUndefined: true},
        flags: {
            type:                   OEObjectModelValueTypes.integer,
            editType:               OEObjectModelValueEditTypes.dropdown,
            entries: [
                {value: OEFunctionShowMediaFlags.none, label: 'none'},
                {value: OEFunctionShowMediaFlags.autoplay, label: 'auto play'},
                {value: OEFunctionShowMediaFlags.autoclose, label: 'auto close'},
                {value: OEFunctionShowMediaFlags.autoplay | OEFunctionShowMediaFlags.autoclose, label: 'auto play & close'}
            ],
            defaultDropdownTitle:   'none'
        }
    },

    debugOutput: {
        text:                       {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Text', showType: false}
    },

    setNoteText: {
        reference: {
            type:                   OEObjectModelValueTypes.group,
            label:                  'Referencing',
            subItems: {
                userRefs:                   {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Note User Reference', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
            }
        },
        text:                       {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Text', showType: false}
    },

    changeNoteProps: {
        reference: {
            type:                   OEObjectModelValueTypes.group,
            label:                  'Referencing',
            subItems: {
                userRefs:                   {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Note User Reference', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
                autosave:                   {type: OEObjectModelValueTypes.bool, label: 'Autosave', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        },
        parameters: {
            type:                   OEObjectModelValueTypes.group,
            label:                  'Note Properties',
            styleOptions:           OEObjectModelValueCellStyleOptions.collapsible,
            collapsed:              true,
            subItems: {
                text:                       {type: OEObjectModelValueTypes.string, undefinedEditable: true, label: 'Text', showType: false},
                hidden:                     {type: OEObjectModelValueTypes.bool, allowUndefined: true, label: 'Hidden', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
                disabled:                   {type: OEObjectModelValueTypes.bool, allowUndefined: true, label: 'Disabled', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
                active:                     {type: OEObjectModelValueTypes.bool, allowUndefined: true, label: 'Active', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
                textViewerEditable:         {type: OEObjectModelValueTypes.bool, allowUndefined: true, label: 'Text Viewer Editable', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
                activeViewerEditable:       {type: OEObjectModelValueTypes.bool, allowUndefined: true, label: 'Viewer Activatable', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
                linkPointViewerEditable:    {type: OEObjectModelValueTypes.bool, allowUndefined: true, label: 'Link Point Viewer Editable', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        }
    },

    applyNoteAddState: {
        reference: {
            type:                   OEObjectModelValueTypes.group,
            label:                  'Referencing',
            subItems: {
                userRefs:                   {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Note User Reference', showType: false},
                addStateUserRefs:           {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'State User Reference', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
                autosave:                   {type: OEObjectModelValueTypes.bool, label: 'Autosave', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        }
    },

    saveNote: {
        reference: {
            type:                   OEObjectModelValueTypes.group,
            label:                  'Referencing',
            subItems: {
                userRefs:                   {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Note User Reference', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        }
    },

    triggerNoteAttrSignal: {
        reference: {
            type:                   OEObjectModelValueTypes.group,
            label:                  'Referencing',
            subItems: {
                userRefs:                   {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Note User Reference', showType: false},
                attributeUserRefs:          {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Attribute User Reference', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
                signals:                    {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Signal', showType: false}
            }
        }
    },

    changePresNoteProps: {
        reference: {
            type:                   OEObjectModelValueTypes.group,
            label:                  'Referencing',
            subItems: {
                presUserRef:                {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Presentation User Reference', showType: false},
                userRefs:                   {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Note User Reference', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        },
        parameters: {
            type:                   OEObjectModelValueTypes.group,
            label:                  'Note Properties',
            styleOptions:           OEObjectModelValueCellStyleOptions.collapsible,
            collapsed:              true,
            subItems: {
                text:                       {type: OEObjectModelValueTypes.string, undefinedEditable: true, label: 'Text', showType: false},
                hidden:                     {type: OEObjectModelValueTypes.bool, allowUndefined: true, label: 'Hidden', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
                disabled:                   {type: OEObjectModelValueTypes.bool, allowUndefined: true, label: 'Disabled', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
                active:                     {type: OEObjectModelValueTypes.bool, allowUndefined: true, label: 'Active', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
                textViewerEditable:         {type: OEObjectModelValueTypes.bool, allowUndefined: true, label: 'Text Viewer Editable', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
                activeViewerEditable:       {type: OEObjectModelValueTypes.bool, allowUndefined: true, label: 'Viewer Activatable', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
                linkPointViewerEditable:    {type: OEObjectModelValueTypes.bool, allowUndefined: true, label: 'Link Point Viewer Editable', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        }
    },

    applyPresNoteAddState: {
        reference: {
            type:                   OEObjectModelValueTypes.group,
            label:                  'Referencing',
            subItems: {
                presUserRef:                {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Presentation User Reference', showType: false},
                userRefs:                   {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Note User Reference', showType: false},
                addStateUserRefs:           {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'State User Reference', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        }
    },

    triggerPresNoteAttrSignal: {
        reference: {
            type:                   OEObjectModelValueTypes.group,
            label:                  'Referencing',
            subItems: {
                presUserRef:                {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Presentation User Reference', showType: false},
                userRefs:                   {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Note User Reference', showType: false},
                attributeUserRefs:          {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Attribute User Reference', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
                signals:                    {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Signal', showType: false}
            }
        }
    },

    changeSlideProps: {
        reference: {
            type:                   OEObjectModelValueTypes.group,
            label:                  'Referencing',
            subItems: {
                presUserRef:                {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Presentation User Reference', showType: false},
                userRefs:                   {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Slide User Reference', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        },
        showInPlayerPreview:        {type: OEObjectModelValueTypes.bool, allowUndefined: true, label: 'Show in Preview', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
    },

    changeActiveSlide: {
        userRefs:                   {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Slide User Reference', showType: false},
        animateTransitionSlides:    {type: OEObjectModelValueTypes.bool, label: 'Animate Transition Slides', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
    },

    userNotification:   {
        text:                       {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Text', showType: false},
        alert:                      {type: OEObjectModelValueTypes.bool, label: 'Alert', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
    },

    applyPreset: {
        reference: {
            type:                   OEObjectModelValueTypes.group,
            label:                  'Referencing',
            subItems: {
                name:                       {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Preset Name', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        },
        animate:                    {type: OEObjectModelValueTypes.bool, label: 'Animated', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
        animationDuration:          {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.0, step: 0.001, label: 'Animation Duration', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
    },

    changeComponent: {
        reference: {
            type:                   OEObjectModelValueTypes.group,
            label:                  'Referencing',
            subItems: {
                id:                         {type: OEObjectModelValueTypes.string, allowUndefined: true, label: 'Component ID', showType: false},
                glob:                       {type: OEObjectModelValueTypes.bool, label: 'Enable Globbing', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]}
            }
        },
        animate:                    {type: OEObjectModelValueTypes.bool, label: 'Animated', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
        animationDuration:          {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.0, step: 0.001, label: 'Animation Duration', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
        renderMode: {
            type:                   OEObjectModelValueTypes.integer,
            editType:               OEObjectModelValueEditTypes.dropdown,
            entries: [
                {value: undefined, label: ''},
                {value: OERenderMode.opaque, label: 'Opaque'},
                {value: OERenderMode.transparent, label: 'Transparent'},
                {value: OERenderMode.hide, label: 'Hidden'}
            ],
            defaultDropdownTitle:   undefined
        },
        //alpha:                    {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.0, max: 1.0, step: 0.001, label: 'Alpha', showType: false, styleOptions: [OEObjectModelValueCellStyleOptions.inlineBar]},
    },

    modelForType(type)   {
        let str = OEFunctionFragmentType.toString(type);
        return str && this[str] ? this[str] : {};
    }
};

//
export const OEFunctionProps = {

    functionFragmentTypeDecl: PropTypes.oneOf(
        [
            OEFunctionFragmentType.setMediaCenterItem,
            OEFunctionFragmentType.showMedia,
            OEFunctionFragmentType.debugOutput,
            OEFunctionFragmentType.setNoteText,
            OEFunctionFragmentType.changeNoteProps,
            OEFunctionFragmentType.applyNoteAddState,
            OEFunctionFragmentType.saveNote,
            OEFunctionFragmentType.triggerNoteAttrSignal,
            OEFunctionFragmentType.changePresNoteProps,
            OEFunctionFragmentType.applyPresNoteAddState,
            OEFunctionFragmentType.triggerPresNoteAttrSignal,
            OEFunctionFragmentType.changeSlideProps,
            OEFunctionFragmentType.changeActiveSlide,
            OEFunctionFragmentType.userNotification,
            OEFunctionFragmentType.applyPreset,
            OEFunctionFragmentType.changeComponent
        ]
    ),

    fragmentDecl: {
        type:                       PropTypes.number.isRequired,
    }
};

OEFunctionProps.addFragmentMenuTypes = PropTypes.arrayOf(
    PropTypes.oneOfType([
        OEFunctionProps.functionFragmentTypeDecl,
        PropTypes.shape({
            type:                       OEFunctionProps.functionFragmentTypeDecl.isRequired,
            allowMultipleInstances:     PropTypes.bool,
            incompatibleTypes:          PropTypes.oneOfType([OEFunctionProps.functionFragmentTypeDecl, PropTypes.arrayOf(OEFunctionProps.functionFragmentTypeDecl)])
        })
    ])
);

OEFunctionProps.fragment = PropTypes.shape(OEFunctionProps.fragmentDecl);

OEFunctionProps.funcDecl = {
    fragments:                      PropTypes.arrayOf(OEFunctionProps.fragment),
};

OEFunctionProps.func = PropTypes.shape(OEFunctionProps.funcDecl);

OEFunctionProps.propTypes = {
    moduleId:                       PropTypes.string,
    className:                      PropTypes.string,
    headerClassName:                PropTypes.string,
    icon:                           PropTypes.string,
    title:                          PropTypes.string,
    titleId:                        PropTypes.string,
    headerSeparator:                PropTypes.bool,
    addButtonInHeader:              PropTypes.bool,
    disabled:                       PropTypes.bool,
    onToggle:                       PropTypes.func,
    addFragmentMenuTypes:           OEFunctionProps.addFragmentMenuTypes,
    func:                           OEFunctionProps.func,
    onChange:                       PropTypes.func
};

OEFunctionProps.defaultProps = {
    moduleId:                       '',
    className:                      '',
    titleId:                        'function_view',
    headerSeparator:                false,
    addButtonInHeader:              false,
    disabled:                       false,
    addFragmentMenuTypes: [
        OEFunctionFragmentType.setMediaCenterItem,
        OEFunctionFragmentType.showMedia,
        {type: OEFunctionFragmentType.setNoteText, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.changeNoteProps, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.applyNoteAddState, allowMultipleInstances: true},
        OEFunctionFragmentType.saveNote,
        {type: OEFunctionFragmentType.triggerNoteAttrSignal, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.changePresNoteProps, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.applyPresNoteAddState, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.triggerPresNoteAttrSignal, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.changeSlideProps, allowMultipleInstances: true},
        OEFunctionFragmentType.changeActiveSlide,
        OEFunctionFragmentType.userNotification,
        //{type: OEFunctionFragmentType.debugOutput, allowMultipleInstances: true}
    ]
};